module.exports = __webpack_public_path__ + "b6690626036a7d6824632769305b1978.ttf";